import accounting from "accounting"

const centsToFormatted = (cents, currency) => {
  const format = currency.symbolFirst ? "%s%v" : "%v%s"
  return accounting.formatMoney(
    cents / currency.subunitToUnit,
    currency.symbol,
    currency.exponent,
    currency.thousandsSeparator,
    currency.decimalMark,
    format
  )
}

const centsToUnformatted = (cents, currency) => {
  const format = "%v"
  return accounting.formatMoney(
    cents / currency.subunitToUnit,
    currency.symbol,
    currency.exponent,
    currency.thousandsSeparator,
    currency.decimalMark,
    format
  )
}

export { centsToFormatted }
export { centsToUnformatted }
